import { Loader } from '@googlemaps/js-api-loader';
import { WrapperProps } from '@googlemaps/react-wrapper';
import React, { useEffect, useRef, ReactElement, useState } from 'react';
export enum Status {
  LOADING = 'LOADING',
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}
const render = (status: Status): ReactElement => {
  if (status === Status.LOADING) return <h3>{status} ..</h3>;
  if (status === Status.FAILURE) return <h3>{status} ...</h3>;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore this is from google maps oficial example
  return null;
};

function MyMapComponent({
  latLng,
  zoom,
  hasMarker,
}: {
  latLng: google.maps.LatLngLiteral;
  zoom: number;
  hasMarker?: boolean;
}) {
  const ref = useRef() as React.MutableRefObject<HTMLInputElement>;

  useEffect(() => {
    const map = new window.google.maps.Map(ref.current as HTMLElement, {
      center: latLng,
      zoom,
    });
    if (hasMarker) {
      new google.maps.Marker({
        position: latLng,
        map,
        title: 'GINDUMAC!',
      });
    }
  });

  return <div ref={ref} id='map' className='h-full min-h-[20em] w-full' />;
}

export default function Map({
  lat,
  lng,
  hasMarker,
}: {
  lat: number;
  lng: number;
  hasMarker?: boolean;
}) {
  const latLng = { lat, lng };
  const zoom = 12;

  return (
    <Wrapper apiKey='AIzaSyC-m683jD7drEx007ajOj9Dl-MQMuCqiC4' render={render}>
      <MyMapComponent latLng={latLng} zoom={zoom} hasMarker={hasMarker} />
    </Wrapper>
  );
}

export const Wrapper = ({
  children,
  render,
  callback,
  ...options
}: WrapperProps): ReactElement => {
  const [status, setStatus] = useState(Status.LOADING);

  useEffect(() => {
    const loader = new Loader(options);

    const setStatusAndExecuteCallback = (status: Status) => {
      if (callback) callback(status, loader);
      setStatus(status);
    };

    setStatusAndExecuteCallback(Status.LOADING);

    loader.load().then(
      () => setStatusAndExecuteCallback(Status.SUCCESS),
      () => setStatusAndExecuteCallback(Status.FAILURE)
    );
  }, [callback, options]);

  if (status === Status.SUCCESS && children) return <>{children}</>;

  if (render) return render(status);

  return <></>;
};
